module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    class: {
      active: _vm.plan.active
    },
    attrs: {
      "xs12": "",
      "md4": "",
      "plan": ""
    }
  }, [_c('div', {
    staticClass: "plan-wrapper"
  }, [_c('h3', {
    staticClass: "mb-3"
  }, [_vm._v(_vm._s(_vm.plan.title))]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.plan.list), function(n, i) {
    return _c('div', {
      key: i,
      staticClass: "item dflex align-start mb-3"
    }, [_c('span', {
      staticClass: "dflex"
    }, [_c('svg', {
      attrs: {
        "width": "20",
        "height": "20",
        "viewBox": "0 0 20 20",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M8.57421 14.8225C8.20317 14.8225 7.85174 14.681 7.62655 14.437L4.57886 11.1464C4.48463 11.0447 4.41584 10.9289 4.37642 10.8056C4.33699 10.6822 4.32771 10.5537 4.3491 10.4274C4.37049 10.3011 4.42213 10.1795 4.50107 10.0695C4.58001 9.95953 4.6847 9.86334 4.80916 9.78645C4.93358 9.70924 5.07541 9.65285 5.22655 9.62051C5.37768 9.58817 5.53514 9.58053 5.6899 9.59801C5.84465 9.61549 5.99367 9.65776 6.12839 9.72239C6.26312 9.78702 6.38092 9.87275 6.47503 9.97465L8.48039 12.1382L13.5223 5.52204C13.6896 5.30359 13.956 5.14826 14.2632 5.09011C14.5703 5.03196 14.8932 5.07575 15.1609 5.21186C15.7179 5.49485 15.8894 6.0943 15.5413 6.55015L9.58414 14.3638C9.48245 14.4978 9.34228 14.6095 9.1758 14.6892C9.00931 14.7689 8.82155 14.8141 8.6288 14.8211C8.61004 14.8225 8.59298 14.8225 8.57421 14.8225Z",
        "fill": "black"
      }
    })])]), _vm._v(" "), _c('p', {
      staticClass: "mb-0",
      domProps: {
        "innerHTML": _vm._s(n)
      }
    }, [_vm._v("\n          " + _vm._s(n) + "\n        ")])])
  })), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('h5', {
    staticClass: "mb-5 mt-15"
  }, [_vm._v("$" + _vm._s(_vm.plan.price) + " "), _c('span', [_vm._v("/month")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "plan_btn",
    nativeOn: {
      "click": function($event) {
        _vm.openPaymentDialog(_vm.plan.stripePriceId)
      }
    }
  }, [_vm._v(" Start free trial ")])], 1), _vm._v(" "), (_vm.showCardModal) ? _c('cardModal', {
    attrs: {
      "amount": _vm.plan.price,
      "stripePriceId": _vm.plan.stripePriceId,
      "dismiss": _vm.closePaymentDialog
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05432b6d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing3/Plan.vue
// module id = 1599
// module chunks = 180